const gerar_arquivo_texto_de_alunos_sem_codigo_inep = [
  {
    path: "/gerar-arquivo-texto-de-alunos-sem-codigo-inep",
    name: "gerar_arquivo_texto_de_alunos_sem_codigo_inep",
    meta: {
      breadCrumb: "Censo Escolar - Código Inep",
      allowedPermissions: ["inep_aluno_sem_codigo_inep"],
    },
    component: () =>
      import(
        "@/views/GerarArquivoTextoDeAlunosSemCodigoInep/GerarArquivoTextoDeAlunosSemCodigoInep.vue"
      ),
  },
];

export { gerar_arquivo_texto_de_alunos_sem_codigo_inep };
